import { render, staticRenderFns } from "./AuditLogDetailsFormatter.vue?vue&type=template&id=07c50cdc&scoped=true&"
import script from "./AuditLogDetailsFormatter.vue?vue&type=script&lang=js&"
export * from "./AuditLogDetailsFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c50cdc",
  null
  
)

export default component.exports